/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitacoesPendentesHistoricosAliases {
  AVATAR_DATA_TP_HISTORICO = 'avatar-data-tpHistorico',
  DECK_0 = 'deck-0',
  FETCH_HISTORICOS = 'fetch-historicos',
  FIELD_DATA_TP_HISTORICO = 'field-data-tpHistorico',
  FIELD_DS_HISTORICO = 'field-dsHistorico',
  FRAGMENT_0 = 'fragment-0',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  MAPPER_DATA_TP_HISTORICO = 'mapper-data-tpHistorico',
  PANEL_0 = 'panel-0',
  PANEL_SOLICITACOES_PENDENTES_HISTORICOS = 'panel-solicitacoes-pendentes-historicos',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_0 = 'tab-with-content-0',
  TAB_WITH_CONTENT_1 = 'tab-with-content-1',
  TEXT_DS_HISTORICO = 'text-dsHistorico',
}
export { SolicitacoesPendentesHistoricosAliases };
